/** Possible states for a pseudo checkbox. */
export type FmntsCheckboxState = 'unchecked' | 'checked';

/**
 * Creates a `FmntsCheckboxState` from a boolean value.
 */
export function fromBoolean(value: boolean): FmntsCheckboxState {
  return value ? 'checked' : 'unchecked';
}
